import { WEBSOCKET_ERROR, WEBSOCKET_STATUS, WEBSOCKET_CONNECT } from './types';

export const doReportWebsocketError = (code: number, messages: string[]) => ({
    type: WEBSOCKET_ERROR,
    payload: {
        code,
        messages
    }
});

export const doReportWebsocketStatus = (status: number) => ({
    type: WEBSOCKET_STATUS,
    payload: { status }
});

export const doWebsocketReconnect = () => ({
    type: WEBSOCKET_CONNECT,
    meta: { reconnect: true }
});
